const ancestor = "AI助研";
const ActivityRouter = [
    /* AI助研首页 */
    {
        path: "/ai",
        name: "ai",
        meta: { screen: false, title: "活动", keepAlive: true, ancestor },
        component: () => import("@/views/ai/Index.vue"),
    },
    /* 学术论文检索 */
    {
        path: "/ai/search",
        name: "ai-search",
        meta: { screen: false, title: "学术论文检索", ancestor },
        component: () => import("@/views/ai/search/Index.vue"),
    },
    /* 参考文献解读 */
    {
        path: "/ai/referd",
        name: "ai-refer",
        meta: { screen: false, title: "参考文献解读", scene: 1, ancestor },
        component: () => import("@/views/ai/refer/Index.vue"),
    },
    {
        path: "/ai/refer",
        name: "ai-refer",
        meta: { screen: false, title: "参考文献解读", scene: 1, ancestor },
        component: () => import("@/views/ai/lab/Index.vue"),
    },
    {
        path: "/ai/refer/chat",
        name: "ai-refer-chat",
        meta: { screen: false, title: "参考文献解读", scene: 1, ancestor },
        component: () => import("@/views/ai/refer/ReferChat.vue"),
    },
    /* 审稿意见解读 */
    {
        path: "/ai/review",
        name: "ai-review",
        meta: { screen: false, title: "审稿意见解读", scene: 2, ancestor },
        // component: () => import("@/views/ai/review/Index.vue"),
        component: () => import("@/views/ai/lab/Index.vue"),
    },
    /* 实验方法解读 */
    {
        path: "/ai/lab",
        name: "ai-lab",
        meta: { screen: false, title: "实验方法解读", scene: 3, ancestor, },
        component: () => import("@/views/ai/lab/Index.vue"),
    },
];
export default ActivityRouter;
